
import { Component, Inject, OnInit, ViewChild, ElementRef, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { calculateFiscalYear, formatYear } from 'src/app/shared/commen-function-file';
import { MatSelectChange } from '@angular/material/select';
import { DataRefreshService } from 'src/app/services/dataRefreshService.service';
import { ToastrService } from 'ngx-toastr';
interface CandidatePayload {
  candidateId?: any;
  companyId: any;
  fiscalYear: any;
  month: any;
  name: any;
  phone: any;
  email: any;
  positionAppliedFor: any;
  applicationDate: any;
  resumeFile: any;
  source: any;
  yearOfExperience: any;
  skills: any;
  education: any;
  expectedSalary: any;
  noticePeriod: any;

}

@Component({
  selector: 'app-add-edit-candidate-popup',
  templateUrl: './add-edit-candidate-popup.component.html',
  styleUrls: ['./add-edit-candidate-popup.component.scss'],
})
export class AddEditCandidatePopupComponent implements OnInit {
  @ViewChild('resumeInput') resumeInput!: ElementRef<HTMLInputElement>;

  candidateForm!: FormGroup;
  isEditMode = false;
  isSubmitting = false;
  loading = false;

  selectedResumeName: string | null = null;
  // sources = ['LinkedIn', 'Naukri', 'Internal Website', 'Other'];
  sources:any;
  positionsList: any[] = [];
  filteredPositions: any[] = [];

  buttonColorName: string | null = null;
  subModuleButtonColor: string | null = null;
  loggedInUserCompanyID: number | null = null;
  loggedInCompanyFiscalyear: any | null = null;
  loggedInUserEmpCode: string | null = null;
  intHODempCode: string | null = null;
  loggedInUserId: string | null = null;
  loggedInUserRole: any | null = null;
  loggedInUserRoles: any[] = [];
  loggedInUserRoleIsEmployee: boolean = false;
  loggedInCompanyMDCode: string | null = null;
  loggedInCompanyReviewCycle: string | null = null; 
  positionRequisitionYears: any[] = [];
  selectedYearForRecruitment: string = '';
  fromYear: string = '';
  toYear: string = '';
  taskFromDate: any = null;
  taskToDate: any = null;
  selectedMonth: string = '';
  editingCandidateId: string | number | null = null;
  jobDescription: string = ''; 
  userName: any;
  
  maxDobDate: Date = new Date();
  readonly months = [
    { key: '01', name: 'January' }, { key: '02', name: 'February' }, { key: '03', name: 'March' },
    { key: '04', name: 'April' }, { key: '05', name: 'May' }, { key: '06', name: 'June' },
    { key: '07', name: 'July' }, { key: '08', name: 'August' }, { key: '09', name: 'September' },
    { key: '10', name: 'October' }, { key: '11', name: 'November' }, { key: '12', name: 'December' }
  ];

  get arrAllMonths() {
    return this.loggedInCompanyFiscalyear === 'Apr_Mar'
      ? [...this.months.slice(3), ...this.months.slice(0, 3)]
      : this.months;
  }
  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    @Optional() private dialogRef: MatDialogRef<AddEditCandidatePopupComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private encryptionService: EncryptionService,
    private httpService: HttpService,
    private config: Config,
    public dialog: MatDialog,
    private dataRefreshService: DataRefreshService,
    private toastr: ToastrService,

  ) { }

  ngOnInit(): void {
    this.initializeSessionData();
    this.getPmsYearList();
    this.isEditMode = !!this.data?.candidateData?.candidate;

    const candidate = this.data?.candidateData?.candidate || {};
    this.initForm(candidate);

    if (this.isEditMode) {
      this.editingCandidateId = candidate.id; // ✅ set the ID here
      this.candidateForm.patchValue(candidate);
      // console.log(candidate);
      if (candidate.resumeFile) {
        this.selectedResumeName = candidate.resumeFile.split('/').pop() || '';
      }
    }
 
    this.candidateForm.get('positionAppliedFor')?.valueChanges.subscribe((positionId: number) => {
      const pos = this.positionsList.find(p => p.positionId === positionId);
      const desc = pos ? pos.jobDescription : 'No job description available.';
      this.candidateForm.get('jobDescription')?.setValue(desc);
    });
    
    this.fetchPositions();

    this.candidateForm.get('email')?.valueChanges.subscribe(() => {
      this.errorMessage = null;
    });
    
  }
  fetchSources(): void {  
    // const url = `${this.config.getJobPlatforms}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForRecruitment}&month=${this.selectedMonth}`;
    const url = `${this.config.getJobPlatforms}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForRecruitment}`;

    this.httpService.callGetService(url).subscribe({
      next: (res: any) => {
        let data = res || [];
  
        data = data
          .filter((x: any) => !x.isDeleted)
          .map((x: any) => ({
            ...x,
            jobPlatformType: x.jobPlatformCode ? 'Firm' : 'Job Platform'
          }));
  
          this.sources = data;
      },
      error: (err: any) => {
        // console.error('Error fetching Job Platforms:', err);
        this.toastr.error('Failed to fetch Job Platforms.', 'Error');
      }
    });
  }
  
  initializeSessionData(): void {
    const decrypt = (key: string) => {
      const val = sessionStorage.getItem(key);
      return val ? this.encryptionService.decryptData(val) : null;
    };
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');

    const companyId = sessionStorage.getItem('loggedInUserCompanyID');
    this.loggedInUserCompanyID = companyId ? Number(this.encryptionService.decryptData(companyId)) : null;
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    this.intHODempCode = this.loggedInUserEmpCode;
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    this.loggedInCompanyFiscalyear = decrypt('loggedInCompanyFiscalyear');
    this.loggedInUserRole = decrypt('loggedInUserRole');
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInUserRoleIsEmployee = this.loggedInUserRoles.length === 1 && this.loggedInUserRoles[0].displayName === 'Employee';
    this.userName = sessionStorage.getItem('loggedInUserName');
  }

  getPmsYearList(): void {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.positionRequisitionYears = formatYear(data?.data?.yearRanges, this.loggedInCompanyFiscalyear);
      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
      const defaultYear = `${fiscalStartYear}-${fiscalEndYear}`;
      this.setSelectedYear(defaultYear);
      this.setDefaultMonth();
      this.fetchSources();

    });
  }

  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.positionRequisitionYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForRecruitment = selectedYearObj.year;
      [this.fromYear, this.toYear] = selectedYearObj.year.split('-');
    }
  }

  onYearChange(year: string): void {
    this.selectedYearForRecruitment = year;
    this.taskFromDate = null;
    this.taskToDate = null;
    this.setDefaultMonth();
  }

  setDefaultMonth(): void {
    const currentMonthKey = new Date().toISOString().slice(5, 7);
    const found = this.arrAllMonths.find(m => m.key === currentMonthKey);
    this.selectedMonth = found ? found.key : this.arrAllMonths[0].key;
  }

  onMonthChange(event: MatSelectChange): void {
    this.selectedMonth = event.value;
  }
  private initForm(candidate: any): void {
    this.candidateForm = this.fb.group({
      name: [candidate.name || '', [Validators.required, Validators.maxLength(100)]],
      phone: [
        candidate.phone || '',
        [Validators.required, Validators.pattern(/^\d{10}$/),  Validators.maxLength(10),
          Validators.minLength(10)]
      ],
      email: [candidate.email || '', [Validators.required, Validators.email,Validators.maxLength(100)]],
      positionAppliedFor: [candidate.positionId  || '', Validators.required],
      applicationDate: [candidate.applicationDate || new Date(), Validators.required],
      resume: [candidate.resumeFile || '', Validators.required],
      source: [candidate.source || '', Validators.required ],
      experienceYears: [candidate.yearOfExperience ?? null, [Validators.required, Validators.min(0), Validators.max(99)]],
      expectedSalary: [candidate.expectedSalary || '', [Validators.required, Validators.maxLength(20)]],
      skills: [candidate.skills || '', [Validators.required, Validators.maxLength(200)]],
      education: [candidate.education || '', [Validators.required, Validators.maxLength(150)]],
      noticePeriod: [candidate.noticePeriod ?? null, [Validators.required, Validators.min(0), Validators.max(999)]],
      // New fields
      currentCtc: [candidate.currentCtc || '', [Validators.maxLength(20)]],
      currentLocation: [candidate.currentLocation || '', [Validators.required,Validators.maxLength(100)]],
      preferredLocation: [candidate.preferredLocation || '', [Validators.required,Validators.maxLength(100)]],
      dob: [candidate.dob ? new Date(candidate.dob) : null],
      // jobDescription: [{ value: ''}],
      jobDescription: [candidate.jobDescription || ''],  
      positionCreatedById: [null],
      positionCreatedByName: [null],
      positionCreatedByUserRole:[null],
      candidateCreatedById: [null],
      candidateCreatedByName: [null],
      candidateCreatedByUserRole:[null],
      positionId:[null]
    });
  }

  private formatDate(date: Date): string {
    const d = new Date(date);
    return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
  }

  onlyNumberKey(event: KeyboardEvent): boolean {
    return /^[0-9]$/.test(event.key);
  }
  
  errorMessage: any;
  onSubmit(): void {
    if (this.candidateForm.valid) {
      this.isSubmitting = true;
      this.loading = true;
      this.errorMessage = null;
      const formValue = this.candidateForm.value;
      // const selectedPosition = formValue.positionAppliedFor;
      const selectedPosition = this.positionsList.find(
        (p: any) => p.positionId === formValue.positionAppliedFor
      ); 
  
      const formatDate = (date: Date): string => {
        const d = new Date(date);
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const year = d.getFullYear();
        return `${year}-${month}-${day}`;
      };
  
      // ✅ Extract hods
      const hods = (selectedPosition?.hods || []).map((h: any) => ({
        hodId: h.hodId,
        hodName: h.hodName
      }));
  
      const payload: any = {
        companyId: this.loggedInUserCompanyID,
        fiscalYear: this.selectedYearForRecruitment,
        month: this.selectedMonth,
        name: formValue.name,
        phone: formValue.phone,
        email: formValue.email,
        positionAppliedFor: selectedPosition?.positionName,
        positionId: selectedPosition?.positionId,
        positionCreatedById: selectedPosition?.positionCreatedById,
        positionCreatedByName: selectedPosition?.positionCreatedByName, 
        positionCreatedByUserRole: selectedPosition?.positionCreatedByUserRole, 
        hods: hods, 
        applicationDate: formValue.applicationDate ? formatDate(formValue.applicationDate) : null,
        source: formValue.source,
        yearOfExperience: formValue.experienceYears,
        skills: formValue.skills,
        education: formValue.education,
        expectedSalary: formValue.expectedSalary,
        noticePeriod: formValue.noticePeriod, 
        currentCtc: formValue.currentCtc || null,
        currentLocation: formValue.currentLocation || '',
        preferredLocation: formValue.preferredLocation || '',
        dob: formValue.dob ? formatDate(formValue.dob) : null,
        ...(this.isEditMode
          ? {
              candidateCreatedById: formValue.candidateCreatedById,
              candidateCreatedByName: formValue.candidateCreatedByName,
              candidateCreatedByUserRole: formValue.candidateCreatedByUserRole
            }
          : {
              candidateCreatedById: this.loggedInUserId,
              candidateCreatedByName: this.userName,
              candidateCreatedByUserRole: this.loggedInUserRole
            })
      };
  
      // console.log('🔍 Form Submission Payload:', payload);
  
      const formData = new FormData();
      formData.append('dto', JSON.stringify(payload));
  
      if (formValue.resume) {
        formData.append('resumeFile', formValue.resume);
      }
  
      const endpoint = this.isEditMode
        ? `${this.config.updateCandidateData}/${this.editingCandidateId}`
        : this.config.addCandidateData;
  
      const request$ = this.isEditMode
        ? this.httpService.submitFileService(endpoint, formData, 'PUT')
        : this.httpService.submitFileService(endpoint, formData, 'POST');
  
      request$.subscribe({
        next: (res:any) => {
          // this.dataRefreshService.triggerRefresh();
          // this.toastr.success(
          //   this.isEditMode
          //     ? 'Candidate updated successfully.'
          //     : 'Candidate added successfully.',
          //   'Success'
          // );
          // this.dialogRef.close();
          // this.loading = false;
          if (res?.status) {
            // ✅ Close only if status is true
            this.toastr.success(
              this.isEditMode ? 'Updated successfully' : 'Applied successfully',
              'Success',
              { timeOut: 3000, progressBar: true }
            );
            this.dialogRef.close(true);
          } else {
            // ❌ Keep dialog open, show inline message
            this.errorMessage = res?.message || 'Something went wrong.';
            this.toastr.error(this.errorMessage, 'Error', {
              timeOut: 4000,
              progressBar: true,
              closeButton: true,
            });
          }
          this.isSubmitting = false;
        },
        error: (err) => {
          // console.error("Error saving/updating candidate:", err);
          this.toastr.error(
            this.isEditMode
              ? 'Failed to update candidate.'
              : 'Failed to add candidate.',
            'Error'
          );
          this.loading = false;
        }
      });
    } else {
      this.candidateForm.markAllAsTouched();
      const invalidFields = Object.entries(this.candidateForm.controls)
        .filter(([_, control]) => control.invalid)
        .map(([key, control]) => ({ key, errors: control.errors }));
      // console.warn('Invalid fields:', invalidFields);
    }
  }
  

  onResumeUpload(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input?.files?.[0];
    if (!file) return;
    if (!input.files?.length) return; 
    const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
  
    if (!allowedTypes.includes(file.type)) {
      this.toastr.error('Only PDF or Word documents are allowed.');
      input.value = ''; // Clear invalid file
      return;
    }
    this.selectedResumeName = file.name;
    this.candidateForm.patchValue({ resume: file });
    this.candidateForm.get('resume')?.updateValueAndValidity();
  }

  onReset(): void {
    this.candidateForm.reset();
    this.resumeInput.nativeElement.value = '';
  }

  cancel(): void {
    this.dialogRef.close();
  }
 
 
  fetchPositions(): void {
    const url = `${this.config.getPositionDetails}?companyId=${this.loggedInUserCompanyID}`;
    this.httpService.callGetService(url).subscribe({
      next: (res: any) => { 
        this.positionsList = (res?.data || [])
        .map((item: any) => ({
          positionId: item.positionId,
          positionName: item.positionName,
          positionCreatedById:item.positionCreatedById,
          positionCreatedByName:item.positionCreatedByName,
          positionCreatedByUserRole:item.positionCreatedByUserRole,
          jobDescription: item.jobDescription,
          hods: item.hods || []
        }))
        .sort((a: any, b: any) => a.positionName.localeCompare(b.positionName));
      
        this.filteredPositions = [...this.positionsList];
   
        if (this.isEditMode) {
          const candidate = this.data?.candidateData?.candidate;
          this.editingCandidateId = candidate.id; 
          const candidatePosition = this.positionsList.find(
            (p: any) => p.positionId === candidate.positionId
          );
          this.candidateForm.patchValue({
            ...candidate,
            positionAppliedFor: candidatePosition?.positionId || null
          });
  
          if (candidate.resumeFile) {
            this.selectedResumeName = candidate.resumeFile.split('/').pop() || '';
          }
        }
      },
      error: (err) => {} // console.error('Error fetching positions:', err),
    });
  }
  
  clearResume(): void {
    this.selectedResumeName = null;

    // Reset file input
    const fileInput = document.getElementById('resumeUpload') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
